/**
* Announcement Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Announcement Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CookieUtil} from './cookieUtil';
( function( app ) {
  const COMPONENT = {

    className: 'announcement-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      class AnnouncementBanner {
        // Static getters for configurable values
        #selectors = {
          banner: '#announcement-banner',
          root: ':root',
          closeButton: '#announcement-banner__close',
        };
        #cssVars = {
          bannerHeight: '--announcementBannerHeight',
        };

        #cookieName = 'll-announcement-banner-' + location.hostname.split( '.' )[0] + '-seen';
        constructor() {
          this.$banner = $( this.#selectors.banner );
          this.$root = $( this.#selectors.root );
          this.$closeButton = $( this.#selectors.closeButton );
          this.#bindEvents();
          this.#updateHeight();
        }
        #bindEvents() {
          const resizeThrottle = new app.components.common.Throttle( () => this.#updateHeight(), 250 );
          $( window ).on( 'resize', () => resizeThrottle.run() );

          this.$closeButton.on( 'click', () => {
            this.#close();
            CookieUtil.setCookie( this.#cookieName, 'true' );
          } );
        }
        /**
         * Closes the banner by sliding it up and setting the CSS banner variable to 0.
         */
        #close() {
          this.$banner.slideUp( 0, () => {
            this.$root.css( this.#cssVars.bannerHeight, '0px' );
          } );
        }
        /**
         * Open the banner by sliding it down, updating the CSS banner variable, and trigger a banner height update.
         */
        #open() {
          this.$banner.slideDown( 0, () => {
            this.#updateHeight();
          } );
        }
        /**
         * If the banner is visible, calculates its height and updates the CSS variable.
         */
        #updateHeight() {
          if ( this.$banner.not( '[style*="display:none"]' ).length ) {
            const height = this.$banner.outerHeight();
            this.$root.css( this.#cssVars.bannerHeight, `${height}px` );
          }
        }
        static init() {
          const banner = new AnnouncementBanner();
          if ( CookieUtil.getCookie( banner.#cookieName ) !== 'true' ) {
            banner.#open();
          }
        }
      }
      AnnouncementBanner.init();
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'announcement-banner', COMPONENT );
} )( app );
